import { CircularProgress, Link } from '@mui/material'
import { getConformtyZip } from 'controllers/conformity/index'
import { useState } from 'react'

interface ConformityZipDownloadLinkProps {
  disabled?: boolean
  vehicleGuid?: string
  vin?: string
}

export default function ConformityZipDownloadLink({ disabled, vehicleGuid, vin }: ConformityZipDownloadLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  return (
    <Link
      onClick={() => {
        if (disabled || isSubmitting || !vehicleGuid || !vin) return

        setIsSubmitting(true)
        getConformtyZip(vehicleGuid, `${vin}.zip`).finally(() => setIsSubmitting(false))
      }}
      sx={{ cursor: disabled ? 'not-allowed' : isSubmitting ? 'wait' : 'pointer' }}
    >
      {isSubmitting ? <CircularProgress size={16} /> : 'Download'}
    </Link>
  )
}
